import type { Location } from "@/types/location";
import { LocationItem } from "./LocationItem";

interface LocationTileProps {
  location: Location;
  organizationName?: string;
}

export function LocationTile({ location, organizationName }: LocationTileProps) {
  return (
    <LocationItem location={location} organizationName={organizationName} asLink />
  );
}
